import cn from 'classnames';
import React from 'react';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { Loader } from '../../../Loader';
import { AriaNode } from '../AriaNode';
import s from './styles.scss';

export interface IMarkCardPrimaryProps {
  primary: boolean;
  isExpired: boolean;
  label?: string;
  markCardPrimary: () => void;
  rtl: boolean;
}

interface IMarkCardPrimaryPassedProps {
  isLoading: boolean;
  setAsDefaultRef: React.RefObject<any>;
}

interface IMarkCardPrimaryConnectedProps {
  mobile: boolean;
}

export const MarkCardPrimary: React.FC<
  IMarkCardPrimaryProps & IMarkCardPrimaryPassedProps & IMarkCardPrimaryConnectedProps
> = (props) => {
  if (props.primary) {
    return (
      <div
        className={cn({
          [s.defaultCard]: true,
          [s.defaultCardRTL]: props.rtl,
          [s.mobile]: props.mobile,
        })}
        data-hook={DH.CardRow.PrimaryLabel}
      >
        {t('app.card.default-card')}
      </div>
    );
  }

  if (props.isExpired) {
    return null;
  }

  return (
    <AriaNode
      ref={props.setAsDefaultRef}
      className={cn(s.markCardPrimary, {
        [s.mobile]: props.mobile,
        [s.loading]: props.isLoading,
        [s.expired]: props.isExpired,
      })}
      onClick={(e) => {
        e.stopPropagation();
        props.markCardPrimary();
      }}
      role="button"
      data-hook={DH.CardRow.SetAsPrimary}
      aria-label={`${t('app.card.make-primary')} ${props.label ? props.label : ''}`}
    >
      {props.isLoading && (
        <div className={s.loader}>
          <Loader size="xsmall" />
        </div>
      )}
      {props.isLoading ? t('app.card.make-primary.loading') : t('app.card.make-primary')}
    </AriaNode>
  );
};
MarkCardPrimary.displayName = 'MarkCardPrimary';
